import endPoints from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

const getIfInboxHasAi = (sourceId) => {
  const urlData = endPoints.getIfInboxHasAi(sourceId);

  return API.get(urlData.url);
};

const handoverInboxAiSession = (sourceId) => {
  const urlData = endPoints.handoverInboxAiSession(sourceId);
  return API.get(urlData.url);
};

const changeAiNest = (sourceId, nestId) => {
  const urlData = endPoints.changeAiNest();

  return API.post(urlData.url, {
    sourceId: sourceId,
    nestId: nestId,
  });
};

export { getIfInboxHasAi, handoverInboxAiSession, changeAiNest };
